module.exports = __webpack_public_path__ + "184075e4.svg";